import handleDhamaMoves from "../dhamaMoves/handleDhamaMoves";
import {
  R1,
  L1,
  R1L3,
  R1L2R1,
  R1L1R1L1,
  R1L1R2,
  R4,
  R3L1,
  R2L2,
  R2L1R1,
  L1R3,
  L1R2L1,
  L1R1L1R1,
  L1R1L2,
  L4,
  L3R1,
  L2R2,
  L2R1L1,
} from "../playersMoves/playerTwoMovesLogic";
import {
  R1_P1,
  L1_P1,
  R1L3_P1,
  R1L2R1_P1,
  R1L1R1L1_P1,
  R1L1R2_P1,
  R4_P1,
  R3L1_P1,
  R2L2_P1,
  R2L1R1_P1,
  L1R3_P1,
  L1R2L1_P1,
  L1R1L1R1_P1,
  L1R1L2_P1,
  L4_P1,
  L3R1_P1,
  L2R2_P1,
  L2R1L1_P1,
} from "../playersMoves/playerOneMovesLogic";
import checkMustEat from "./checkMustEat";
import EatMore from "../eatMore/eatMore";
import changeFromPawnToDhama from "../dhamaMoves/changeFromPawnToDhama";
import one from "../../assets/eat.mp3";
let prevSquareIndexForMustEat;
let temptArrayToremoveSelectionInMustEat = [];
function handleMustEat(
  pawnsInTouch,
  x,
  i,
  j,
  squareRef,
  squareRefPawns,
  boardData,
  setBoardData,
  playerTurn,
  prevSquare,
  setPrevSquare,
  setPlayerTurn,
  boardDataRef,
  countMustForP1,
  countMustForP2,
  tempPrevousPawnP1,
  tempPrevousPawnP2,
  dhamaIndex,
  matrixOfPawns,
  mustEat,
  mustEatWhithDhama,
  mustEatWhithDhamaArray,
  finalAllWays,
  pawnsToEat,
  activeSound
) {
  const clickedSquareData = boardData.find(
    (square) => square[1] === i && square[2] === j
  );
  const [squareColor, row, col] = clickedSquareData;
  const currentSquareIndex = row * 10 + col;
  // let countP1 = 0;
  // let countP2 = 0;
  let justOneDhamaToEatP1;
  let justOneDhamaToEatP2;

  for (let i = 0; i < dhamaIndex.length; i++) {
    if (mustEatWhithDhamaArray.length === 1) {
      if (playerTurn === 1) {
        justOneDhamaToEatP1 = mustEatWhithDhamaArray[0];
      } else if (playerTurn === 2) {
        justOneDhamaToEatP2 = mustEatWhithDhamaArray[0];
      }
    }
    // if (dhamaIndex[i][0] === 31) {
    //   countP1++;
    //   justOneDhamaToEatP1 = dhamaIndex[i][1];
    // } else if (dhamaIndex[i][0] === 32) {
    //   countP2++;
    //   justOneDhamaToEatP2 = dhamaIndex[i][1];
    // }
  }
  let eatWhithDhama = false;
  // if (prevSquareIndexForMustEat !== undefined) {
  if (
    (!mustEatWhithDhama &&
      playerTurn === 1 &&
      countMustForP1 === 1 &&
      tempPrevousPawnP1 !== undefined) ||
    (!mustEatWhithDhama &&
      playerTurn === 2 &&
      countMustForP2 === 1 &&
      tempPrevousPawnP2 !== undefined)
  ) {
    if (playerTurn === 1) {
      prevSquareIndexForMustEat = tempPrevousPawnP1;
      squareRef.current[prevSquareIndexForMustEat].classList.add("gray-box");
      squareRef.current[prevSquareIndexForMustEat].classList.remove(
        "box-waiting-for-selection"
      );
    } else if (playerTurn === 2) {
      prevSquareIndexForMustEat = tempPrevousPawnP2;
      squareRef.current[prevSquareIndexForMustEat].classList.add("gray-box");
      squareRef.current[prevSquareIndexForMustEat].classList.remove(
        "box-waiting-for-selection"
      );
    }
  }

  if (
    (!mustEat && playerTurn === 1 && justOneDhamaToEatP1) ||
    (!mustEat && playerTurn === 2 && justOneDhamaToEatP2)
  ) {
    if (playerTurn === 1) {
      prevSquareIndexForMustEat = justOneDhamaToEatP1;
      squareRef.current[prevSquareIndexForMustEat].classList.add("gray-box");
      squareRef.current[prevSquareIndexForMustEat].classList.remove(
        "box-waiting-for-selection"
      );
    } else if (playerTurn === 2) {
      prevSquareIndexForMustEat = justOneDhamaToEatP2;
      squareRef.current[prevSquareIndexForMustEat].classList.add("gray-box");
      squareRef.current[prevSquareIndexForMustEat].classList.remove(
        "box-waiting-for-selection"
      );
    }
  }

  if (mustEat) {
    for (let i = 0; i < pawnsInTouch.length; i++) {
      const minValue = Math.min(pawnsInTouch[i][0], pawnsInTouch[i][1]);
      const maxValue = Math.max(pawnsInTouch[i][0], pawnsInTouch[i][1]);
      //! deuble check it  if i need to add a playerturn
      if (pawnsInTouch[i].length === 3) {
        if (currentSquareIndex === minValue) {
          prevSquareIndexForMustEat = minValue;
          squareRef.current[prevSquareIndexForMustEat].classList.add(
            "gray-box"
          );
          squareRef.current[pawnsInTouch[i][0]].classList.remove(
            "box-waiting-for-selection"
          );
          squareRef.current[pawnsInTouch[i][1]].classList.remove(
            "box-waiting-for-selection"
          );
          break;
        } else if (currentSquareIndex === maxValue) {
          {
            prevSquareIndexForMustEat = maxValue;
            squareRef.current[prevSquareIndexForMustEat].classList.add(
              "gray-box"
            );
            squareRef.current[pawnsInTouch[i][0]].classList.remove(
              "box-waiting-for-selection"
            );
            squareRef.current[pawnsInTouch[i][1]].classList.remove(
              "box-waiting-for-selection"
            );
            break;
          }
        } else if (currentSquareIndex === maxValue + 18 && playerTurn === 1) {
          prevSquareIndexForMustEat = maxValue;
          break;
        } else if (currentSquareIndex === minValue + 22 && playerTurn === 1) {
          prevSquareIndexForMustEat = minValue;
          break;
        } else if (currentSquareIndex === maxValue - 22 && playerTurn === 2) {
          prevSquareIndexForMustEat = maxValue;
          break;
        } else if (currentSquareIndex === minValue - 18 && playerTurn === 2) {
          prevSquareIndexForMustEat = minValue;
          break;
        }
      } else if (pawnsInTouch[i].length === 2) {
        if (currentSquareIndex === minValue && playerTurn === 1) {
          prevSquareIndexForMustEat = minValue;
          squareRef.current[prevSquareIndexForMustEat].classList.add(
            "gray-box"
          );
          break;
        } else if (currentSquareIndex === maxValue && playerTurn === 2) {
          prevSquareIndexForMustEat = maxValue;
          squareRef.current[prevSquareIndexForMustEat].classList.add(
            "gray-box"
          );
          break;
        }
      }
    }
  }
  if (mustEatWhithDhama) {
    if (
      mustEatWhithDhamaArray.includes(currentSquareIndex) ||
      mustEatWhithDhamaArray.includes(prevSquareIndexForMustEat)
    ) {
      if (mustEatWhithDhamaArray.includes(currentSquareIndex)) {
        prevSquareIndexForMustEat = currentSquareIndex;
        squareRef.current[prevSquareIndexForMustEat].classList.add("gray-box");
      }
      eatWhithDhama = true;
    } else {
    }
  }

  let handleDhamaMovesFromMustEat = false;

  if (eatWhithDhama) {
    handleDhamaMovesFromMustEat = true;
    if (prevSquareIndexForMustEat !== undefined) {
      const [executedDhama, temptArrayToremoveSelection] = handleDhamaMoves(
        boardDataRef,
        i,
        j,
        squareRef,
        squareRefPawns,
        boardData,
        setBoardData,
        playerTurn,
        prevSquare,
        setPrevSquare,
        setPlayerTurn,
        x,
        finalAllWays,
        matrixOfPawns,
        dhamaIndex,
        pawnsToEat,
        pawnsInTouch,
        prevSquareIndexForMustEat,
        handleDhamaMovesFromMustEat,
        activeSound,
        mustEatWhithDhamaArray
      );

      temptArrayToremoveSelectionInMustEat = temptArrayToremoveSelection;
      if (executedDhama) {
        if (activeSound) {
          new Audio(one).play();
        }
        x = 1;
        for (let i = 0; i < pawnsInTouch.length; i++) {
          if (pawnsInTouch[i].length === 3) {
            squareRef.current[pawnsInTouch[i][0]].classList.remove("gray-box");
            squareRef.current[pawnsInTouch[i][1]].classList.remove("gray-box");
            squareRef.current[pawnsInTouch[i][0]].classList.remove(
              "box-waiting-for-selection"
            );
            squareRef.current[pawnsInTouch[i][1]].classList.remove(
              "box-waiting-for-selection"
            );
          } else if (pawnsInTouch[i].length === 2) {
            squareRef.current[pawnsInTouch[i][0]].classList.remove("gray-box");
            squareRef.current[pawnsInTouch[i][0]].classList.remove(
              "box-waiting-for-selection"
            );
            squareRef.current[pawnsInTouch[i][1]].classList.remove("gray-box");
            squareRef.current[pawnsInTouch[i][1]].classList.remove(
              "box-waiting-for-selection"
            );
          }
        }
        for (let i = 0; i < dhamaIndex.length; i++) {
          squareRef.current[dhamaIndex[i][1]].classList.remove(
            "box-waiting-for-selection"
          );
          squareRef.current[dhamaIndex[i][1]].classList.remove("gray-box");
        }
      } else if (
        !(
          ((boardData[currentSquareIndex][0] === 2 ||
            boardData[currentSquareIndex][0] === 32) &&
            playerTurn === 2) ||
          ((boardData[currentSquareIndex][0] === 1 ||
            boardData[currentSquareIndex][0] === 31) &&
            playerTurn === 1)
        )
      ) {
        x = 3;
        const mustEat = document.querySelector(".must-eat");
        if (mustEat) {
          mustEat.style.display = "block";
          setTimeout(() => {
            mustEat.style.display = "none";
          }, 1000);
        }
      } else {
        x = 3;
      }
    } else {
      x = 3;
      if (prevSquareIndexForMustEat === undefined) {
        const chooseMustEat = document.querySelector(".choose-must-eat");
        if (chooseMustEat) {
          chooseMustEat.style.display = "block";
          setTimeout(() => {
            chooseMustEat.style.display = "none";
          }, 1000);
        }
      }
    }
  } else {
    if (
      (boardData[currentSquareIndex][0] === 2 && playerTurn === 2) ||
      (boardData[currentSquareIndex][0] === 1 && playerTurn === 1)
    ) {
      if (temptArrayToremoveSelectionInMustEat.length > 0) {
        temptArrayToremoveSelectionInMustEat.forEach((subArray) => {
          subArray.forEach((element) => {
            element.forEach((index) => {
              squareRef.current[index].classList.remove(
                "box-waiting-for-selection"
              );
            });
          });
        });

        while (temptArrayToremoveSelectionInMustEat.length > 0) {
          temptArrayToremoveSelectionInMustEat.shift();
        }
      }
    }

    let moves = [];
    if (playerTurn === 2) {
      moves = [
        R1,
        L1,
        R1L3,
        R1L2R1,
        R1L1R1L1,
        R1L1R2,
        R4,
        R3L1,
        R2L2,
        R2L1R1,
        L1R3,
        L1R2L1,
        L1R1L1R1,
        L1R1L2,
        L4,
        L3R1,
        L2R2,
        L2R1L1,
      ];
    } else {
      moves = [
        R1_P1,
        L1_P1,
        R1L3_P1,
        R1L2R1_P1,
        R1L1R1L1_P1,
        R1L1R2_P1,
        R4_P1,
        R3L1_P1,
        R2L2_P1,
        R2L1R1_P1,
        L1R3_P1,
        L1R2L1_P1,
        L1R1L1R1_P1,
        L1R1L2_P1,
        L4_P1,
        L3R1_P1,
        L2R2_P1,
        L2R1L1_P1,
      ];
    }
    let executed = false;
    if (
      prevSquareIndexForMustEat !== undefined &&
      pawnsInTouch.some((subArr) => subArr.includes(prevSquareIndexForMustEat))
    ) {
      for (let i = 0; i < moves.length; i++) {
        const move = moves[i];
        if (
          move(
            prevSquareIndexForMustEat,
            currentSquareIndex,
            boardData,
            setPlayerTurn,
            playerTurn,
            squareRef,
            squareRefPawns,
            setBoardData
          )
        ) {
          if (activeSound) {
            new Audio(one).play();
          }
          executed = true;
          setTimeout(() => {
            changeFromPawnToDhama(
              prevSquareIndexForMustEat,
              currentSquareIndex,
              boardData,
              setPlayerTurn,
              playerTurn,
              squareRef,
              squareRefPawns,
              boardDataRef,
              dhamaIndex,
              activeSound
            );
            x = EatMore(
              prevSquareIndexForMustEat,
              currentSquareIndex,
              boardData,
              setPlayerTurn,
              playerTurn,
              squareRefPawns,
              setBoardData
            );
            if (x !== 2) {
              checkMustEat(
                prevSquareIndexForMustEat,
                currentSquareIndex,
                boardData,
                playerTurn,
                pawnsInTouch
              );
            }
          });
          break;
        }
      }
    }
    if (executed) {
      x = 1;
      setPrevSquare([row, col]);
      for (let i = 0; i < pawnsInTouch.length; i++) {
        if (pawnsInTouch[i].length === 3) {
          squareRef.current[pawnsInTouch[i][0]].classList.remove("gray-box");
          squareRef.current[pawnsInTouch[i][1]].classList.remove("gray-box");
          squareRef.current[pawnsInTouch[i][0]].classList.remove(
            "box-waiting-for-selection"
          );
          squareRef.current[pawnsInTouch[i][1]].classList.remove(
            "box-waiting-for-selection"
          );
        } else if (pawnsInTouch[i].length === 2) {
          squareRef.current[pawnsInTouch[i][0]].classList.remove("gray-box");
          squareRef.current[pawnsInTouch[i][0]].classList.remove(
            "box-waiting-for-selection"
          );
          squareRef.current[pawnsInTouch[i][1]].classList.remove("gray-box");
          squareRef.current[pawnsInTouch[i][1]].classList.remove(
            "box-waiting-for-selection"
          );
        }
      }
      if (mustEatWhithDhamaArray !== undefined) {
        for (let i = 0; i < mustEatWhithDhamaArray.length; i++) {
          squareRef.current[mustEatWhithDhamaArray[i]].classList.remove(
            "gray-box",
            "box-waiting-for-selection"
          );
        }
      }
      pawnsInTouch = pawnsInTouch.filter(
        (subArr) => !subArr.includes(prevSquareIndexForMustEat)
      );
    } else {
      x = 3;
      if (
        !(
          ((boardData[currentSquareIndex][0] === 2 ||
            boardData[currentSquareIndex][0] === 32) &&
            playerTurn === 2) ||
          ((boardData[currentSquareIndex][0] === 1 ||
            boardData[currentSquareIndex][0] === 31) &&
            playerTurn === 1)
        )
      ) {
        const mustEat = document.querySelector(".must-eat");
        if (mustEat) {
          mustEat.style.display = "block";
          setTimeout(() => {
            mustEat.style.display = "none";
          }, 1000);
        }
      }
    }
  }

  return [x, pawnsInTouch];
}
export default handleMustEat;
